import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../Utils/api";
import axios from "axios";

const initialState = {
  loading: false,
  overviewLoading: false,
  error: null,
  portfolioMetrics: null,
  portfolioOverview: null,
};

export const getPortfolioMetrics = createAsyncThunk(
  "portfolio/getPortfolioMetrics",
  async () => {
    const token = localStorage.getItem("auth-token");
    const response = await axios({
      method: "GET",
      url: `${baseUrl}/quotation/dashboard/portfolio-overview-metrics`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  }
);

export const getPortfolioOverview = createAsyncThunk(
  "portfolio/getPortfolioOverview",
  async (date) => {
    const token = localStorage.getItem("auth-token");
    const dateParam = date ? `?date=${date}` : "";
    const response = await axios({
      method: "GET",
      url: `${baseUrl}/quotation/dashboard/portfolio-overview${dateParam}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  }
);

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getPortfolioMetrics.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getPortfolioMetrics.fulfilled, (state, action) => {
      state.loading = false;
      state.portfolioMetrics = action.payload?.result ?? null;
    });
    builder.addCase(getPortfolioMetrics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    builder.addCase(getPortfolioOverview.pending, (state) => {
      state.overviewLoading = true;
    });
    builder.addCase(getPortfolioOverview.fulfilled, (state, action) => {
      state.overviewLoading = false;
      state.portfolioOverview = action.payload?.result ?? null;
    });
    builder.addCase(getPortfolioOverview.rejected, (state, action) => {
      state.overviewLoading = false;
      state.error = action.error.message;
    });
  },
});

export default portfolioSlice.reducer;
